import React from 'react';

import ArrowIcon from '@swf/core/assets/icons/arrow.svg';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import panelStyles from '../PanelItem/PanelItem.scss';

const PanelItemInfo: React.FC<React.PropsWithChildren> = ({ children }) => (
  <>
    <ArrowIcon className={panelStyles.arrow} />
    <div className={panelStyles.info}>{children}</div>
  </>
);

export default PanelItemInfo;
